import { makeStyles } from '@material-ui/core/styles';

const RULE = '#e4e4e8';
const INK_2 = '#4a4a52';

export const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        fontWeight: 600,
        marginBottom: 16,
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 12,
        padding: '16px 0',
        borderBottom: `1px solid ${RULE}`,
        '&:last-child': {
            borderBottom: 'none',
        },
    },
    rowInfo: {
        flex: 1,
        minWidth: 0,
    },
    rowName: {
        fontWeight: 600,
    },
    rowPrice: {
        display: 'block',
        marginTop: 2,
        color: INK_2,
        fontSize: 13,
    },
    rowPriceValue: {
        fontWeight: 600,
    },
    rowDesc: {
        color: theme.palette.text.secondary,
        marginTop: 4,
    },
    rowControl: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        minWidth: 88,
        justifyContent: 'flex-end',
    },
}));
